import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  Tooltip
} from '@material-ui/core';
import MUITextField from '@material-ui/core/TextField';
import { AddCircle, Delete, InfoOutlined } from '@material-ui/icons';
import FormContext from 'components/Form/FormContext';
import {
  getAvailableLanguages,
  getConfigs,
  getLanguage
} from 'features/app/selectors';
import { onChangeMarketSettingsData } from 'features/MarketSettingContainer/actions';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from 'utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  tableHeader: {
    background: '#a6c9ec',
    padding: '3px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  inputField: {
    padding: '0px',
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '10px !important',
      borderRadius: '0px'
    }
  },
  addButton: {
    float: 'right'
  }
}));

const globalSalesPoint = [
  'Restaurant',
  'Bistro',
  'Cafe',
  'Swedish Food Market',
  'Swedish Deli',
  'Swedish Bite',
  'Snack',
  'Co-worker Restaurant',
  'Food truck',
  'Bakery'
];

const defaultSalesPoints = ['962', '963', '964'];

const SalesPointsTabContent = () => {
  const classes = useStyles();
  const language = useSelector(getLanguage);
  const dispatch = useDispatch();
  const { data, setFieldValue } = useContext(FormContext);
  const globalUten = data.salesPoint.filter(num =>
    defaultSalesPoints.includes(num.code)
  );
  const remaining = data.salesPoint.filter(
    num => !defaultSalesPoints.includes(num.code)
  );
  const [salesPointList, setSalesPointList] = useState(
    [...globalUten, ...remaining] || []
  );
  const languages = toJS(useSelector(getAvailableLanguages));
  const langauageLabels = useSelector(getConfigs).toJS().languageDisplayLabels;

  // const languages = rawLanguages.toJS()

  function createLanguageDisplayLabel(data) {
    const result = {};
    data.forEach(i => {
      result[i.languageCode] = i.displayLabel;
    });
    return result;
  }

  const addSalesPoint = () => {
    const newSalesPoints = {
      id: '',
      code: '',
      info: languages.reduce((acc, lang) => {
        acc[lang] = { slug: '', name: '' };
        return acc;
      }, {}),
      // info: {
      //   [language]: {
      //     slug: '',
      //     name: ''
      //   }
      // },
      active: false,
      isActive: false
    };
    dispatch(
      onChangeMarketSettingsData({
        ...data,
        salesPoint: [...salesPointList, newSalesPoints]
      })
    );
    setSalesPointList([...salesPointList, newSalesPoints]);
    setFieldValue('salesPoint', [...salesPointList, newSalesPoints]);
  };
  const onDeleteSalesPoint = deletedIndex => {
    const updatedSalesPoints = salesPointList.filter(
      (_, index) => index !== deletedIndex
    );
    setSalesPointList(updatedSalesPoints);
    dispatch(
      onChangeMarketSettingsData({ ...data, salesPoint: updatedSalesPoints })
    );
    setFieldValue('salesPoint', updatedSalesPoints);
  };

  const onChangeSalesPoint = (e, index, key) => {
    const updatedValue = e.target.value;
    const updatedList = salesPointList.map((salesPoint, ind) => {
      if (ind === index) {
        delete salesPoint.info[language].message;
        const missingLanguages = []; // Track languages with missing slugs
        languages.forEach(lang => {
          if (key === 'slug') {
            salesPoint.info[lang][key] = updatedValue;
            delete salesPoint.info[lang].message;
          }
          if (!salesPoint.info[lang].slug.trim()) {
            missingLanguages.push(`"${lang}"`); // Collect missing language names
          }
        });
        if (missingLanguages.length === 0) {
          delete salesPoint.message;
        }
        return {
          ...salesPoint,
          info: {
            ...salesPoint.info,
            [language]: {
              ...salesPoint.info[language],
              [key]: updatedValue // Dynamically update slug/name
            }
          }
          // message: ""
        };
      }
      return salesPoint;
    });
    setSalesPointList(updatedList);
    dispatch(onChangeMarketSettingsData({ ...data, salesPoint: updatedList }));
    // Sync with form state
    setFieldValue('salesPoint', updatedList);
  };

  const onChangeCheckBox = (e, index) => {
    const updatedValue = e.target.checked;
    const updatedList = salesPointList.map((salesPoint, ind) =>
      ind === index
        ? { ...salesPoint, active: updatedValue, isActive: updatedValue }
        : salesPoint
    );
    setSalesPointList(updatedList);
    setFieldValue('salesPoint', updatedList);
    dispatch(onChangeMarketSettingsData({ ...data, salesPoint: updatedList }));
  };

  return (
    <div>
      <Grid
        container
        className={classes.tableHeader}
        spacing={2}
        rowSpacing={1}
      >
        <Grid item sm={1} />
        <Grid item sm={5}>
          Name
        </Grid>
        <Grid item sm={5}>
          Translated Display Text
        </Grid>
        <Grid item sm={1} />
      </Grid>
      {salesPointList.length > 0 &&
        salesPointList.map((item, index) => {
          // const defaultSalesPoints = ['962', '963', '964'];
          const disabledSPs = globalSalesPoint.find(
            sp => sp === item.info[language].slug
          );
          const missingLanguages = []; // Track languages with missing slugs
          languages.forEach(lang => {
            if (!item.info[lang].slug.trim()) {
              missingLanguages.push(
                `"${createLanguageDisplayLabel(langauageLabels)[lang]}"`
              ); // Collect missing language names
            }
          });
          return (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item sm={1}>
                <FormControlLabel
                  label=""
                  control={
                    <Checkbox
                      // value={code}
                      checked={
                        // defaultSalesPoints.includes(item.code)
                        //   ? true
                        //   :
                        item.isActive
                      }
                      onChange={e => onChangeCheckBox(e, index)}
                      // disabled={defaultSalesPoints.includes(item.code)}
                    />
                  }
                />
                {missingLanguages.length > 0 && item.message && (
                  <Tooltip
                    title={`Sales point name is missing for ${missingLanguages.join(
                      ', '
                    )}`}
                  >
                    <IconButton
                      style={{ color: '#d11a2a' }}
                      size="small"
                      // disabled={isDisable}
                      // className={classes.addButton}
                    >
                      <InfoOutlined />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
              <Grid item sm={5}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].slug) || ''
                  }
                  onChange={event => onChangeSalesPoint(event, index, `slug`)}
                  inputProps={{ maxLength: 64 }}
                  // style={item.message ? { border: '1px solid red' } : {}}
                  error={item.info[language].message || false}
                  disabled={disabledSPs}
                />
              </Grid>
              <Grid item sm={5}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].name) || ''
                  }
                  onChange={event => onChangeSalesPoint(event, index, `name`)}
                  inputProps={{ maxLength: 64 }}
                />
              </Grid>
              <Grid item sm={1}>
                {item.id === '' && (
                  <IconButton
                    onClick={() => onDeleteSalesPoint(index)}
                    style={{ color: '#d11a2a' }}
                    size="small"

                    // disabled={isDisable}
                  >
                    <Delete />
                  </IconButton>
                )}
                {index === salesPointList.length - 1 && (
                  <IconButton
                    onClick={addSalesPoint}
                    color="secondary"
                    size="small"
                    // disabled={isDisable}
                    className={classes.addButton}
                  >
                    <AddCircle />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          );
        })}
    </div>
  );
};

export default SalesPointsTabContent;
